import { DqlQuery, Query } from '../field';

// Each class should be an interface, but it is easier to define the constant fields in the constructors.
// For now we have only one query language so it is not a problem.
// Always use the public Query namespace for variable definitions so we will be able to introduce other language easily.

export class Company implements Query.NullComparableField {

  readonly id: Query.NumberField;
  readonly name: Query.StringField;

  constructor(prefix?: string) {
    prefix = prefix ? prefix : '';
    this.id = new DqlQuery.NumberField(prefix + 'id');
    this.name = new DqlQuery.StringField(prefix + 'name');
  }

  isNull(): Query.Criteria {
    return this.id.isNull();
  }

  isNotNull(): Query.Criteria {
    return this.id.isNotNull()
  }

}
